export default function closest({
  el,
  selector,
  stopSelector = null,
}) {
  if (el.matches(selector)) {
    return el;
  } else if (stopSelector && el.matches(stopSelector)) {
    return null;
  } else if (el.parentElement) {
    return closest({ el: el.parentElement, selector, stopSelector });
  }
  return null;
}



// WEBPACK FOOTER //
// ./src/scripts/utils/closest.js